import React from 'react';

import memoize from 'lodash.memoize';

import { useIntl } from './IntlContext';

interface Props {
  readonly value: string | number | Date;
  readonly style?: 'with-seconds';
}

const defaultOptions: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

const TimeComponent: React.FC<Props> = ({ value, style }) => {
  const date = new Date(value);
  const { language } = useIntl();
  switch (style) {
    case 'with-seconds':
      return <>{getLongFormatter(language).format(date)}</>;
    default:
      return <>{getFormatter(language).format(date)}</>;
  }
};

const getFormatter = memoize((language: string) => {
  return new Intl.DateTimeFormat(language, defaultOptions);
});

const getLongFormatter = memoize((language: string) => {
  return new Intl.DateTimeFormat(language, { ...defaultOptions, second: '2-digit' });
});

export default React.memo(TimeComponent);
